import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React from "react";
import {useTranslation} from "react-i18next";
import ThirdPartyUserCredential from "../../../models/thirdparty/ThirdPartyUserCredential";
import SecretPropertiesUserCredentialFormBody from "../userCredential/SecretPropertiesUserCredentialFormBody";

const initialProperties = [
    [{value: 'xpack.security.password'}, {value: ''}]
]

function ElasticsearchUserCredentialFormBody(props) {
    return (
        <SecretPropertiesUserCredentialFormBody {...props} type={ThirdPartyUserCredential.Type.ELASTICSEARCH} label="secretProperties"
            initialProperties={initialProperties} SettingRows={ElasticsearchUserCredentialFormBodySettingRows}/>
    )
}

function ElasticsearchUserCredentialFormBodySettingRows(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        thirdPartyService,
        isDisabled
    } = props;

    return (
        <>
            <SettingsRowValue label={t('thirdPartyService:label.hostname')} value={thirdPartyService.hostname}
                isTight isDisabled={isDisabled}/>
        </>
    )
}

export default ElasticsearchUserCredentialFormBody;
